export default __webpack_public_path__ + "static/day-2-20a5f94a981b32b63b60992b03ba9373.gif";